import useTranslation from "../../hooks/useTranslation";
import SurveyDispatch from "../../models/surveyDispatch";
import SurveyDispatchManager from "../../models/surveyDispatchManager";
import DesertImg from "../../styles/illustrations/Desert.png";
import { NoDataState } from "../NoDataState/NoDataState";
import { SurveyDispatchAccordion } from "../SurveyDispatchAccordion/SurveyDispatchAccordion";
import { SurveyLaunchButton } from "../SurveyLaunchButton/SurveyLaunchButton";
import { Typography } from "../ui/Typography/Typography";
import "./SurveyDispatchOverview.scss";

interface SurveyDispatchOverviewProps {
  dispatchManager: SurveyDispatchManager;
  refetchDispatches?: () => void;
  setSuccessMsg?: (msg: string) => void;
  setErrorMsg?: (msg: string) => void;
}
export const SurveyDispatchOverview = ({
  dispatchManager,
  refetchDispatches,
  setSuccessMsg,
  setErrorMsg,
}: SurveyDispatchOverviewProps) => {
  const { t } = useTranslation("workplaceCulturePage");

  let activeDispatches: SurveyDispatch[] = [];
  let completedDispatches: SurveyDispatch[] = [];
  let draftDispatches: SurveyDispatch[] = [];

  if (dispatchManager) {
    ({ activeDispatches, completedDispatches, draftDispatches } =
      dispatchManager.getDispatchesByStatus());
  }

  return (
    <div className="SurveyDispatchOverview">
      <div className="SurveyDispatchOverview__header">
        <SurveyLaunchButton
          color={dispatchManager.dispatches.length > 0 ? "secondary" : "info"}
          canLaunchNewDispatch={dispatchManager.canLaunchNewDispatch()}
          small={dispatchManager.dispatches.length > 0}
        />
      </div>
      {activeDispatches.length > 0 && (
        <div className="SurveyDispatchOverview__group">
          <Typography
            className="SurveyDispatchOverview__group__title"
            desktop="h2"
          >
            {t("dispatches.active.title")}
          </Typography>
          {activeDispatches.map((dispatch, id) => {
            return (
              <div key={id}>
                <SurveyDispatchAccordion key={id} dispatch={dispatch} />
              </div>
            );
          })}
        </div>
      )}
      {draftDispatches.length > 0 && (
        <div className="SurveyDispatchOverview__group">
          <Typography
            className="SurveyDispatchOverview__group__title"
            desktop="h2"
          >
            {t("dispatches.draft.title")}
          </Typography>
          {draftDispatches.map((dispatch, id) => {
            return (
              <div key={id}>
                <SurveyDispatchAccordion
                  key={id}
                  dispatch={dispatch}
                  refetchDispatches={refetchDispatches}
                  setSuccessMsg={setSuccessMsg}
                  setErrorMsg={setErrorMsg}
                />
              </div>
            );
          })}
        </div>
      )}

      {completedDispatches.length > 0 && (
        <div className="SurveyDispatchOverview__group">
          <Typography
            className="SurveyDispatchOverview__group__title"
            desktop="h2"
          >
            {t("dispatches.past.title")}
          </Typography>
          {completedDispatches.map((dispatch, id) => {
            return (
              <div key={id}>
                <SurveyDispatchAccordion
                  key={id}
                  dispatch={dispatch}
                  refetchDispatches={refetchDispatches}
                  setSuccessMsg={setSuccessMsg}
                  setErrorMsg={setErrorMsg}
                />
              </div>
            );
          })}
        </div>
      )}
      {dispatchManager.dispatches.length === 0 && (
        <>
          <NoDataState
            className="QuestionBreakdown__noSelectedFilters"
            title={t("dispatches.noDispatches.title")}
            info={t("dispatches.noDispatches.info")}
            imgSrc={DesertImg}
          />
        </>
      )}
    </div>
  );
};
